/**
 * Las dos pantallas que comparten el tablero: «Estadísticas de atención» (`management`, todo el sitio o un profesional a
 * elección) y «Mi desempeño» (`mine`, solo lo del profesional del usuario).
 */
export type StatisticsMode = 'management' | 'mine';

/**
 * Id de un texto que cambia según la pantalla: en «Mi desempeño» está en primera persona (`ProfessionalPerformance…`);
 * en la de gestión es el de siempre (`ServicesStatistics…`). El sufijo es el mismo y existe en las dos familias.
 */
export const modeMessageId = (mode: StatisticsMode, suffix: string): string =>
    `${mode === 'mine' ? 'ProfessionalPerformance' : 'ServicesStatistics'}${suffix}`;
